import { Component } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";
import { DataService } from "../../../../services/data.service";

@Component({
  selector: "modal-input",
  template: `
    <div class="form-group">
      <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text"><svg class="icon icon-sm"><use href="/assets/svg/sprites.svg#it-pencil"></use></svg></div>
        </div>
        <label [attr.for]="id" *ngIf="props.label">
          {{ props.label }}
          <ng-container *ngIf="props.required">*</ng-container>
        </label>
        <input
          type="text"
          class="form-control"
          name="input-group-3"
          [type]="type"
          [formControl]="formControl"
          [formlyAttributes]="field"
          [class.is-invalid]="showError"
        >
        <div class="input-group-append">
          <button
            *ngIf="props['modable']"
            class="btn btn-primary btn-sm"
            type="button"
            data-bs-toggle="modal"
            [attr.data-bs-target]="'.'+ props['modal']"
          >Open</button>
          <div *ngIf="showError" class="col-3 invalid-feedback d-block">
            <formly-validation-message [field]="field"></formly-validation-message>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
    `
  ]
})

export class ModalInputComponent extends FieldType<FieldTypeConfig> {

  constructor( private ds: DataService ) {
    super();
  }

  get type() {
    return this.props.type || "text";
  }

  ngOnInit() {
    this.ds.modelData$.subscribe(obj => console.log(obj))
  }

  onClick( $event: any ) {
    if (this.props["onClick"]) {
      this.props["onClick"]($event);
      //this.form.get('title')?.value
      //this.form.get('title')?.setValue('testscrittura')
    }
  }
}
